import React from 'react';

const PagamentoSicuro = () => {
  return (
    <svg
      version="1.1"
      id="pagamento_sicuro_icon"
      xmlns="http://www.w3.org/2000/svg"
      xlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 51 49"
      style="enable-background:new 0 0 51 49;"
      space="preserve"
      style={{
        fill: 'none',
        stroke: 'currentColor',
        strokeWidth: 2,
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeMiterlimit: 22.9256,
        verticalAlign: 'middle',
      }}
    >
      <path d="M26.09,34.47H5.92c-1.97,0-3.59-1.62-3.59-3.59V6.37c0-1.98,1.62-3.59,3.59-3.59h38.48 C46.38,2.77,48,4.4,48,6.37v24.5c0,1.97-1.62,3.59-3.59,3.59h-1.64" />
      <line x1="7.4" y1="28.95" x2="11.47" y2="28.95" />
      <line x1="16.41" y1="28.95" x2="21.46" y2="28.95" />
      <polygon points="48,10.32 48,16.17 2.33,16.17 2.33,10.32 48,10.32 " />
      <path d="M27.86,30.13H41.4c0.68,0,1.24,0.56,1.24,1.24v10.25c0,2.28-1.87,4.15-4.15,4.15h-7.73 c-2.28,0-4.15-1.87-4.15-4.15V31.37C26.62,30.69,27.18,30.13,27.86,30.13L27.86,30.13z" />
      <path d="M29.3,29.92v-3.81c0-2.46,2.01-4.48,4.48-4.48h1.71c2.46,0,4.48,2.02,4.48,4.48v3.81 M34.63,35.13 c0.63,0,1.14,0.51,1.14,1.14c0,0.63-0.51,1.14-1.14,1.14c-0.63,0-1.14-0.51-1.14-1.14C33.49,35.64,34,35.13,34.63,35.13L34.63,35.13 z M34.63,40.64v-4.06" />
    </svg>
  );
};

export default PagamentoSicuro;
